import { orderMapper } from '../mappers/order-mapper';
import { apiClient } from '../shared/api-client';
import { logError } from '../shared/error-logger';

const orderRepository = {
    async getAll() {
        try {
            const orders = await apiClient.get({
                url: 'orders'
            });

            return orders.map(orderMapper.toDomain);
        } catch (error) {
            logError(error);

            return [];
        }
    }
};

export {
    orderRepository
};
